var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVespa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#477aff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M239.88,376.125a1.434,1.434,0,0,0-1.455,1.4v2.842a1.455,1.455,0,0,0,2.909,0v-2.842A1.434,1.434,0,0,0,239.88,376.125Z",
    transform: "translate(-233.916 -365.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M91.561,1.754h-2.8a2.62,2.62,0,0,0-4.945,0H81.052a.717.717,0,0,0-.727.7.717.717,0,0,0,.727.7h2.8a2.438,2.438,0,0,0,1.127,1.4,4.627,4.627,0,0,0-3.418,4.386v3.684a1.19,1.19,0,0,0,1.2,1.158h.982v-2a2.583,2.583,0,0,1,5.164,0v2h.982a1.19,1.19,0,0,0,1.2-1.158V8.982A4.6,4.6,0,0,0,87.67,4.6a2.438,2.438,0,0,0,1.127-1.4h2.8a.717.717,0,0,0,.727-.7A.78.78,0,0,0,91.561,1.754Zm-5.273,2.14a1.434,1.434,0,0,1-1.455-1.4,1.455,1.455,0,0,1,2.909,0A1.389,1.389,0,0,1,86.289,3.895Z",
    transform: "translate(-80.325)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVespa);
export default __webpack_public_path__ + "static/media/vespa.161142d0.svg";
export { ForwardRef as ReactComponent };